import React from 'react';
import './Loader.css';

const Loader = () => {
  return <div className='loader'>Loading....</div>;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js